import constants from '@/config/constants.js'

const validModi = [
  {
    name: constants.LIST_MODUS.LIST,
    filterStoreName: 'company',
  },
  {
    name: constants.LIST_MODUS.MULTI_ACTION_EDIT,
    filterStoreName: 'company',
  },
]

export default {
  namespaced: true,

  state: () => {
    return {
      modus: constants.LIST_MODUS.LIST,
      filterStoreName: 'company',
    }
  },

  mutations: {
    SET_MODUS (state, modus) {
      const matchedModusObject = validModi.find(m => m.name === modus)

      if (!matchedModusObject) {
        console.error(`${modus} is not a valid companyUsersListModus`)

        return
      }

      state.modus = matchedModusObject.name
      state.filterStoreName = matchedModusObject.filterStoreName
    },

    FULL_RESET (state) {
      state.modus = constants.LIST_MODUS.LIST
      state.filterStoreName = 'company'
    },
  },
}
